// The AEP renewal wizard is only open during the AEP survey cycle -- or any
// time for a fullserve client, who reviews coverage on their own schedule.
// Mirrors the gate the SurveyJS AEP page enforced in-page via its `page0`
// "no longer available this year" screen (data/survey-aep.js), except this
// keeps the client out of the wizard entirely rather than showing them a dead
// end inside it.
//
// `canAepSurvey` is `isAepSurveyCycle || fullserve` (store/index.js).
export default function ({ store, redirect }) {
    if (!store.getters.canAepSurvey && !store.getters.canAgent) {
        return redirect('/survey')
    }
}
